var _style, _polygon, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPredictalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 88",
    style: {
      enableBackground: "new 0 0 220 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000110444034684534225170000008601149699342251444_);}\n\t.st2{fill:#652581;}\n\t.st3{fill:#E6312B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.4548,
    y1: 9.9847,
    x2: 10.5632,
    y2: 44.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6332A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0356,
    style: {
      stopColor: "#DC3331"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1654,
    style: {
      stopColor: "#B93044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2986,
    style: {
      stopColor: "#9B2D51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    style: {
      stopColor: "#822B5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    style: {
      stopColor: "#6D295F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#5F2863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#572765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#542666"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.4,44.47 32.76,39.64 32.76,3.29 20.4,8.12  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135652818692349922250000012749382571218040238_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8304,
    y1: 6.827,
    x2: 5.1168,
    y2: 43.526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6332A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0356,
    style: {
      stopColor: "#DC3331"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1654,
    style: {
      stopColor: "#B93044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2986,
    style: {
      stopColor: "#9B2D51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    style: {
      stopColor: "#822B5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    style: {
      stopColor: "#6D295F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#5F2863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#572765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#542666"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000135652818692349922250000012749382571218040238_)"
    },
    points: "1,17.38 13.36,22.22 13.36,64.4  1,59.56  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.99,60.74c2.59,0,4.69-2.1,4.69-4.69c0-2.58-2.1-4.68-4.68-4.68H45.53v16.15h2.55V53.96h16.05v4.19H51.47 c-1.22,0-2.44,0.8-3.09,2.04l-0.29,0.55H55l8.58,6.78h3.79l-8.41-6.78H61.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.5,51.37H20.03v16.15h2.55V53.96h16.05v4.19H25.96c-1.22,0-2.43,0.8-3.09,2.04l-0.29,0.55h13.91 c0,0,0,0,0,0c1.25,0,2.43-0.49,3.31-1.37c0.89-0.89,1.37-2.06,1.37-3.31C41.18,53.47,39.08,51.37,36.5,51.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.04,62.91c0.04,2.55,2.13,4.62,4.68,4.62h16.04v-2.59H73.59l0-4.19h11.53v-2.59h-8.15 c-1.22,0-2.43,0.8-3.09,2.04l-0.29,0.55l0-6.82h18.17v-2.55l-20.72,0L71.04,62.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.14,51.37H96.1v16.15h16.04c2.54,0,4.64-2.07,4.68-4.62v-6.91C116.79,53.44,114.69,51.37,112.14,51.37z  M98.65,64.93V53.96h15.62v10.97H98.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.08,55.99v6.92c0.04,2.55,2.14,4.62,4.68,4.62h16.04v-2.59h-18.17V53.96h18.17v-2.59h-16.04 C130.21,51.37,128.11,53.44,128.08,55.99z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.17,
    y: 51.37,
    className: "st2",
    width: 2.55,
    height: 16.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "173.51,51.37 152.14,51.37 152.14,53.92 161.55,53.92 161.55,67.52 164.1,67.52 164.1,53.92  173.51,53.92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.37,67.52h3.2l2.75-3.62h13.04l2.76,3.62h3.2l-12.48-16.39L171.37,67.52z M183.84,55.34l4.55,5.97h-6.99 c-0.9,0-2.07,0.42-2.92,1.07L183.84,55.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.83,64.93V51.37h-2.56l0,11.54c0.04,2.55,2.14,4.62,4.68,4.62H219v-2.59H200.83z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.51,77.79c0.35-0.17,0.62-0.42,0.8-0.75c0.18-0.33,0.27-0.72,0.27-1.18v-1.09c0-0.45-0.09-0.83-0.28-1.15 c-0.18-0.32-0.45-0.56-0.8-0.73c-0.35-0.16-0.77-0.25-1.27-0.25H21.1h-0.5h-0.57V82h1.07v-3.96h1.14c0.07,0,0.14-0.01,0.21-0.01 L23.64,82h1.21l-1.38-4.2C23.48,77.8,23.5,77.79,23.51,77.79z M21.1,77.03v-3.38h1.23c0.25,0,0.46,0.05,0.64,0.14 c0.18,0.1,0.31,0.24,0.41,0.43c0.09,0.19,0.14,0.41,0.14,0.67v0.96c0,0.24-0.05,0.46-0.14,0.63c-0.09,0.18-0.23,0.31-0.41,0.41 c-0.18,0.09-0.39,0.14-0.64,0.14H21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.69,80.17c0,0.29-0.08,0.52-0.24,0.68c-0.16,0.16-0.39,0.24-0.68,0.24c-0.31,0-0.56-0.1-0.73-0.31 c-0.17-0.21-0.26-0.5-0.26-0.87v-0.82h2.93v-1.7c0-0.46-0.08-0.86-0.23-1.18c-0.16-0.32-0.38-0.57-0.68-0.74 c-0.3-0.17-0.66-0.25-1.08-0.25c-0.42,0-0.77,0.09-1.07,0.28c-0.3,0.18-0.52,0.45-0.68,0.8c-0.16,0.35-0.23,0.77-0.23,1.27v2.32 c0,0.47,0.08,0.87,0.24,1.2c0.16,0.33,0.39,0.59,0.69,0.76c0.3,0.17,0.67,0.26,1.1,0.26c0.63,0,1.11-0.17,1.45-0.5 c0.34-0.33,0.51-0.81,0.51-1.42v-0.04l-1.05-0.01V80.17z M31.03,76.53c0.16-0.23,0.39-0.34,0.69-0.34c0.3,0,0.54,0.11,0.7,0.32 c0.16,0.21,0.25,0.51,0.25,0.9v0.75h-1.88v-0.67C30.79,77.07,30.87,76.75,31.03,76.53z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.17,
    y: 75.32,
    className: "st3",
    width: 1.08,
    height: 6.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.17,
    y: 72.87,
    className: "st3",
    width: 1.08,
    height: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.94,75.43c-0.23-0.15-0.52-0.22-0.87-0.22c-0.35,0-0.66,0.11-0.93,0.33c-0.21,0.17-0.37,0.41-0.49,0.71 c-0.02-0.06-0.02-0.12-0.04-0.17c-0.11-0.29-0.28-0.5-0.5-0.65c-0.22-0.15-0.49-0.22-0.8-0.22c-0.36,0-0.67,0.1-0.93,0.31 c-0.19,0.15-0.35,0.36-0.49,0.62v-0.82H45.8V82h1.07v-4.59c0-0.4,0.08-0.7,0.24-0.9s0.4-0.3,0.72-0.3c0.29,0,0.5,0.09,0.64,0.28 c0.14,0.18,0.21,0.46,0.21,0.84V82h1.08v-4.59c0-0.4,0.07-0.7,0.21-0.9c0.14-0.2,0.35-0.3,0.64-0.3c0.32,0,0.56,0.09,0.72,0.28 c0.16,0.18,0.24,0.46,0.24,0.84V82h1.07v-4.85c0-0.42-0.06-0.78-0.18-1.07C52.35,75.79,52.17,75.57,51.94,75.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.19,75.43c-0.3-0.15-0.65-0.23-1.07-0.23c-0.62,0-1.1,0.17-1.43,0.5c-0.34,0.33-0.51,0.8-0.51,1.41 l1.04,0.01c0-0.32,0.07-0.56,0.23-0.73c0.15-0.17,0.37-0.26,0.64-0.26c0.31,0,0.56,0.09,0.73,0.26c0.17,0.17,0.26,0.41,0.26,0.73 v0.87h-0.97c-0.69,0-1.2,0.19-1.54,0.56c-0.34,0.37-0.51,0.93-0.51,1.68c0,0.63,0.14,1.09,0.42,1.4c0.28,0.31,0.71,0.47,1.27,0.47 c0.33,0,0.6-0.05,0.81-0.16c0.21-0.11,0.38-0.27,0.49-0.49c0.02-0.03,0.02-0.07,0.04-0.1V82h1.02v-4.89c0-0.4-0.08-0.75-0.23-1.03 C61.71,75.8,61.49,75.58,61.19,75.43z M60.81,80.92c-0.18,0.19-0.45,0.29-0.81,0.29c-0.32,0-0.55-0.08-0.71-0.24 s-0.23-0.41-0.23-0.74c0-0.45,0.09-0.79,0.26-1.02c0.18-0.23,0.44-0.34,0.79-0.34h0.96v1.18C61.08,80.43,60.99,80.73,60.81,80.92z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.41,76.11c-0.14-0.24-0.3-0.44-0.5-0.59c-0.26-0.21-0.55-0.31-0.87-0.31c-0.33,0-0.61,0.08-0.85,0.24 c-0.23,0.16-0.41,0.4-0.54,0.71c-0.12,0.31-0.19,0.68-0.19,1.12v2.84c0,0.42,0.06,0.77,0.19,1.08c0.12,0.3,0.3,0.53,0.54,0.69 c0.24,0.16,0.52,0.23,0.84,0.23c0.34,0,0.64-0.1,0.9-0.31c0.2-0.16,0.36-0.37,0.47-0.63v1.65c0,0.29-0.08,0.52-0.24,0.68 c-0.16,0.16-0.38,0.24-0.68,0.24c-0.29,0-0.52-0.08-0.68-0.25c-0.16-0.17-0.24-0.4-0.24-0.7v-0.08H67.5v0.08 c0,0.6,0.17,1.08,0.51,1.41c0.34,0.34,0.82,0.51,1.44,0.51c0.43,0,0.8-0.07,1.1-0.22c0.3-0.15,0.54-0.36,0.69-0.64 c0.16-0.28,0.24-0.62,0.24-1.02v-7.51h-1.07V76.11z M70.3,80.65c-0.07,0.16-0.18,0.29-0.32,0.38c-0.14,0.09-0.31,0.13-0.51,0.13 c-0.3,0-0.53-0.09-0.69-0.28s-0.24-0.44-0.24-0.78v-2.8c0-0.36,0.08-0.64,0.24-0.84c0.16-0.2,0.39-0.3,0.69-0.3 c0.2,0,0.37,0.05,0.51,0.14c0.14,0.09,0.25,0.22,0.32,0.39c0.07,0.17,0.11,0.37,0.11,0.61v2.76 C70.41,80.29,70.37,80.49,70.3,80.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.04,
    y: 75.32,
    className: "st3",
    width: 1.08,
    height: 6.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.04,
    y: 72.87,
    className: "st3",
    width: 1.08,
    height: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.17,75.21c-0.36,0-0.67,0.1-0.93,0.31c-0.19,0.15-0.36,0.36-0.49,0.62v-0.81h-1.07V82h1.07v-4.59 c0-0.4,0.08-0.7,0.24-0.9c0.16-0.2,0.4-0.3,0.72-0.3c0.33,0,0.57,0.09,0.73,0.28c0.16,0.18,0.24,0.46,0.24,0.84V82h1.07v-4.85 c0-0.64-0.13-1.12-0.4-1.45S86.69,75.21,86.17,75.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.07,80.17c0,0.29-0.08,0.52-0.24,0.68c-0.16,0.16-0.39,0.24-0.68,0.24c-0.31,0-0.56-0.1-0.73-0.31 c-0.17-0.21-0.26-0.5-0.26-0.87v-0.82h2.93v-1.7c0-0.46-0.08-0.86-0.23-1.18c-0.16-0.32-0.38-0.57-0.68-0.74 c-0.3-0.17-0.66-0.25-1.08-0.25c-0.42,0-0.77,0.09-1.07,0.28c-0.3,0.18-0.52,0.45-0.68,0.8c-0.16,0.35-0.23,0.77-0.23,1.27v2.32 c0,0.47,0.08,0.87,0.24,1.2c0.16,0.33,0.39,0.59,0.69,0.76c0.3,0.17,0.67,0.26,1.1,0.26c0.63,0,1.11-0.17,1.45-0.5 c0.34-0.33,0.51-0.81,0.51-1.42v-0.04l-1.05-0.01V80.17z M94.41,76.53c0.16-0.23,0.39-0.34,0.69-0.34c0.3,0,0.54,0.11,0.7,0.32 c0.16,0.21,0.25,0.51,0.25,0.9v0.75h-1.88v-0.67C94.17,77.07,94.25,76.75,94.41,76.53z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "108.52,73.66 110.25,73.66 110.25,82 111.33,82 111.33,73.66 113.06,73.66 113.06,72.65  108.52,72.65  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.96,80.17c0,0.29-0.08,0.52-0.24,0.68c-0.16,0.16-0.39,0.24-0.68,0.24c-0.31,0-0.56-0.1-0.73-0.31 c-0.17-0.21-0.26-0.5-0.26-0.87v-0.82h2.93v-1.7c0-0.46-0.08-0.86-0.23-1.18c-0.16-0.32-0.38-0.57-0.68-0.74 c-0.3-0.17-0.66-0.25-1.08-0.25c-0.42,0-0.77,0.09-1.07,0.28c-0.3,0.18-0.52,0.45-0.68,0.8c-0.16,0.35-0.23,0.77-0.23,1.27v2.32 c0,0.47,0.08,0.87,0.24,1.2c0.16,0.33,0.39,0.59,0.69,0.76c0.3,0.17,0.67,0.26,1.1,0.26c0.63,0,1.11-0.17,1.45-0.5 c0.34-0.33,0.51-0.81,0.51-1.42v-0.04l-1.05-0.01V80.17z M118.3,76.53c0.16-0.23,0.39-0.34,0.69-0.34c0.3,0,0.54,0.11,0.7,0.32 c0.17,0.21,0.25,0.51,0.25,0.9v0.75h-1.88v-0.67C118.06,77.07,118.14,76.75,118.3,76.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.43,75.43c-0.3-0.15-0.65-0.23-1.07-0.23c-0.62,0-1.1,0.17-1.43,0.5s-0.51,0.8-0.51,1.41l1.04,0.01 c0-0.32,0.07-0.56,0.23-0.73c0.15-0.17,0.37-0.26,0.64-0.26c0.31,0,0.56,0.09,0.73,0.26c0.17,0.17,0.26,0.41,0.26,0.73v0.87h-0.97 c-0.69,0-1.2,0.19-1.54,0.56c-0.34,0.37-0.51,0.93-0.51,1.68c0,0.63,0.14,1.09,0.42,1.4c0.28,0.31,0.71,0.47,1.27,0.47 c0.33,0,0.6-0.05,0.81-0.16c0.21-0.11,0.38-0.27,0.49-0.49c0.02-0.03,0.02-0.07,0.04-0.11V82h1.02v-4.89 c0-0.4-0.08-0.75-0.23-1.03C129.95,75.8,129.73,75.58,129.43,75.43z M129.05,80.92c-0.18,0.19-0.45,0.29-0.81,0.29 c-0.32,0-0.55-0.08-0.71-0.24c-0.16-0.16-0.23-0.41-0.23-0.74c0-0.45,0.09-0.79,0.26-1.02c0.18-0.23,0.44-0.34,0.79-0.34h0.96 v1.18C129.32,80.43,129.23,80.73,129.05,80.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.97,75.43c-0.23-0.15-0.52-0.22-0.87-0.22c-0.35,0-0.66,0.11-0.93,0.33c-0.21,0.17-0.37,0.41-0.49,0.71 c-0.02-0.06-0.02-0.12-0.04-0.17c-0.11-0.29-0.28-0.5-0.5-0.65c-0.22-0.15-0.49-0.22-0.8-0.22c-0.36,0-0.67,0.1-0.93,0.31 c-0.19,0.15-0.35,0.36-0.49,0.62v-0.82h-1.07V82h1.07v-4.59c0-0.4,0.08-0.7,0.24-0.9s0.4-0.3,0.72-0.3c0.29,0,0.5,0.09,0.64,0.28 c0.14,0.18,0.21,0.46,0.21,0.84V82h1.08v-4.59c0-0.4,0.07-0.7,0.21-0.9c0.14-0.2,0.35-0.3,0.64-0.3c0.32,0,0.56,0.09,0.72,0.28 c0.16,0.18,0.24,0.46,0.24,0.84V82h1.07v-4.85c0-0.42-0.06-0.78-0.18-1.07C142.38,75.79,142.2,75.57,141.97,75.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.48,77.38c-0.24-0.17-0.53-0.34-0.89-0.51c-0.02-0.01-0.04-0.02-0.05-0.03 c-0.02-0.01-0.04-0.02-0.06-0.03c-0.03-0.01-0.06-0.03-0.09-0.04c-0.03-0.01-0.06-0.03-0.09-0.05c-0.33-0.15-0.59-0.28-0.78-0.4 c-0.19-0.12-0.34-0.26-0.47-0.44c-0.13-0.18-0.19-0.4-0.19-0.67V74.7c0-0.37,0.1-0.65,0.3-0.84c0.2-0.19,0.5-0.28,0.89-0.28 c0.38,0,0.66,0.1,0.85,0.3c0.19,0.2,0.28,0.5,0.29,0.89v0.46h1.06v-0.49c0-0.48-0.08-0.88-0.25-1.2 c-0.17-0.33-0.41-0.57-0.74-0.74c-0.33-0.16-0.73-0.25-1.21-0.25c-0.5,0-0.91,0.08-1.25,0.24c-0.34,0.16-0.59,0.41-0.76,0.73 c-0.17,0.32-0.25,0.72-0.25,1.19v0.5c0,0.45,0.09,0.82,0.26,1.12c0.18,0.3,0.39,0.53,0.65,0.7c0.25,0.17,0.59,0.36,1,0.55 l0.08,0.04c0.01,0,0.02,0.01,0.03,0.01c0.01,0,0.02,0.01,0.03,0.01c0.31,0.15,0.56,0.28,0.75,0.41c0.19,0.12,0.34,0.28,0.47,0.46 c0.12,0.18,0.18,0.41,0.18,0.68v0.68c0,0.4-0.1,0.7-0.3,0.9s-0.49,0.3-0.88,0.3c-0.4,0-0.7-0.1-0.9-0.3 c-0.2-0.2-0.31-0.5-0.31-0.89v-0.44l-1.07,0.01v0.46c0,0.48,0.09,0.88,0.26,1.21c0.17,0.33,0.43,0.57,0.76,0.74 c0.34,0.17,0.76,0.25,1.26,0.25c0.49,0,0.91-0.08,1.24-0.25c0.33-0.16,0.58-0.41,0.75-0.74c0.17-0.33,0.25-0.73,0.25-1.21v-0.73 c0-0.44-0.08-0.81-0.23-1.1C158.91,77.78,158.72,77.55,158.48,77.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.5,80.17c0,0.29-0.08,0.52-0.24,0.68c-0.16,0.16-0.39,0.24-0.68,0.24c-0.31,0-0.56-0.1-0.73-0.31 c-0.17-0.21-0.26-0.5-0.26-0.87v-0.82h2.93v-1.7c0-0.46-0.08-0.86-0.23-1.18c-0.16-0.32-0.38-0.57-0.68-0.74 c-0.3-0.17-0.66-0.25-1.08-0.25c-0.42,0-0.77,0.09-1.07,0.28c-0.3,0.18-0.52,0.45-0.68,0.8c-0.16,0.35-0.23,0.77-0.23,1.27v2.32 c0,0.47,0.08,0.87,0.24,1.2c0.16,0.33,0.39,0.59,0.69,0.76c0.3,0.17,0.67,0.26,1.1,0.26c0.63,0,1.11-0.17,1.45-0.5 c0.34-0.33,0.51-0.81,0.51-1.42v-0.04l-1.05-0.01V80.17z M165.84,76.53c0.16-0.23,0.39-0.34,0.69-0.34c0.3,0,0.54,0.11,0.7,0.32 c0.17,0.21,0.25,0.51,0.25,0.9v0.75h-1.88v-0.67C165.59,77.07,165.67,76.75,165.84,76.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.14,80.79c-0.11-0.13-0.16-0.32-0.16-0.56v-7.59h-1.07v7.58c0,0.56,0.14,1,0.41,1.31 c0.27,0.31,0.66,0.46,1.15,0.46h0.51v-1.01h-0.4C175.4,80.99,175.25,80.92,175.14,80.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.86,80.17c0,0.29-0.08,0.52-0.24,0.68c-0.16,0.16-0.39,0.24-0.68,0.24c-0.31,0-0.56-0.1-0.73-0.31 c-0.17-0.21-0.26-0.5-0.26-0.87v-0.82h2.93v-1.7c0-0.46-0.08-0.86-0.23-1.18c-0.16-0.32-0.38-0.57-0.68-0.74 c-0.3-0.17-0.66-0.25-1.08-0.25c-0.42,0-0.77,0.09-1.07,0.28c-0.3,0.18-0.52,0.45-0.68,0.8c-0.16,0.35-0.23,0.77-0.23,1.27v2.32 c0,0.47,0.08,0.87,0.24,1.2c0.16,0.33,0.39,0.59,0.69,0.76c0.3,0.17,0.67,0.26,1.1,0.26c0.63,0,1.11-0.17,1.45-0.5 c0.34-0.33,0.51-0.81,0.51-1.42v-0.04l-1.05-0.01V80.17z M182.2,76.53c0.16-0.23,0.39-0.34,0.69-0.34c0.3,0,0.54,0.11,0.7,0.32 c0.17,0.21,0.25,0.51,0.25,0.9v0.75h-1.88v-0.67C181.96,77.07,182.04,76.75,182.2,76.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.16,80.08c0,0.32-0.08,0.57-0.25,0.75c-0.17,0.18-0.41,0.27-0.72,0.27s-0.55-0.09-0.71-0.26 c-0.17-0.17-0.25-0.42-0.25-0.73v-2.8c0-0.35,0.08-0.62,0.25-0.8c0.17-0.19,0.41-0.28,0.71-0.28c0.31,0,0.55,0.1,0.72,0.29 c0.17,0.19,0.25,0.46,0.25,0.81v0.14h1.04v-0.14c0-0.45-0.08-0.83-0.24-1.14c-0.16-0.31-0.39-0.55-0.69-0.72 c-0.3-0.17-0.67-0.25-1.1-0.25c-0.42,0-0.79,0.08-1.09,0.25c-0.3,0.17-0.53,0.4-0.69,0.71c-0.16,0.31-0.24,0.69-0.24,1.13v2.8 c0,0.42,0.08,0.78,0.24,1.08c0.16,0.3,0.39,0.53,0.69,0.68c0.3,0.16,0.66,0.23,1.09,0.23c0.43,0,0.8-0.08,1.11-0.24 c0.3-0.16,0.54-0.39,0.7-0.69s0.24-0.66,0.24-1.09v-0.13l-1.05-0.01V80.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.58,73.38h-1.07v1.94h-0.69v1.01h0.69v3.93c0,0.58,0.13,1.02,0.38,1.32c0.25,0.3,0.65,0.45,1.19,0.45 h0.63v-1.01h-0.5c-0.21,0-0.36-0.07-0.47-0.2c-0.1-0.13-0.16-0.32-0.16-0.56v-3.94h1.12v-1.01h-1.12V73.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M209.7,75.43c-0.28-0.15-0.63-0.23-1.03-0.23c-0.4,0-0.75,0.08-1.04,0.23c-0.29,0.15-0.51,0.37-0.66,0.65 c-0.15,0.29-0.23,0.63-0.23,1.03v3.04c0,0.41,0.08,0.76,0.23,1.05c0.15,0.29,0.37,0.51,0.66,0.67c0.29,0.15,0.64,0.23,1.04,0.23 c0.4,0,0.75-0.08,1.03-0.23c0.29-0.15,0.5-0.37,0.65-0.66c0.15-0.29,0.23-0.64,0.23-1.04v-3.06c0-0.4-0.08-0.75-0.23-1.03 C210.2,75.8,209.98,75.58,209.7,75.43z M209.5,80.15c0,0.29-0.07,0.52-0.22,0.68c-0.15,0.16-0.36,0.24-0.63,0.24 c-0.27,0-0.47-0.08-0.62-0.24c-0.15-0.16-0.22-0.38-0.22-0.68v-3.02c0-0.28,0.07-0.5,0.22-0.66c0.15-0.16,0.35-0.24,0.61-0.24 c0.27,0,0.47,0.08,0.62,0.24c0.15,0.16,0.23,0.38,0.23,0.66V80.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M217.78,75.54c-0.3,0.18-0.56,0.43-0.77,0.74v-0.96h-1.07V82h1.07v-4.22c0.02-0.48,0.19-0.86,0.51-1.13 c0.32-0.27,0.77-0.41,1.33-0.41c0.03,0,0.05,0,0.07,0c0.02,0,0.04,0,0.06,0v-1.04C218.56,75.21,218.15,75.32,217.78,75.54z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictalLogo);
export default __webpack_public_path__ + "static/media/predictal_logo.a916a8142970fd5b7f886199c39a21b9.svg";
export { ForwardRef as ReactComponent };